import { Thunder } from '@nu-art/thunderstorm-frontend/index';
export function getBaseAnalyticsMetadata() {
    return {
        env: Thunder.getInstance().getConfig().label,
    };
}
//# sourceMappingURL=get-metadata.js.map